import { PLURALS } from 'constants/productTypes';

export const pluraliseProductType = (singular) => PLURALS[singular];

export const singularProductType = (plural) =>
  Object.keys(PLURALS).find((type) => PLURALS[type] === plural);
